export default __webpack_public_path__ + "static/media/2223 knife block B top.afeb0028.png";